import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

import { AvatarSize } from "@shared/types/avatarSize";

const UserAvatarDelete_Shared_Mutation = gql`
  mutation UserAvatarDelete_Shared_Mutation($input: UserAvatarDeleteInput!) {
    userAvatarDelete(input: $input) {
      errors {
        message
      }
    }
  }
`;

interface UserAvatarDeleteData {
  userAvatarDelete: {
    errors: {
      message: string;
      fields: {
        userAvatarId?: string[];
      };
    };
  };
}

interface Variables {
  input: {
    userAvatarId: string;
  };
}

const UserAvatar_Shared_Query = gql`
  query UserAvatar_Shared_Query($filter: PhotoSizeFilters!) {
    viewer {
      user {
        id
        avatar {
          id
          photoUrl(filter: $filter)
        }
      }
    }
  }
`;

const useUserAvatarDeleteMutation = (
  options: MutationHookOptions<UserAvatarDeleteData, Variables>
) =>
  useMutation<UserAvatarDeleteData, Variables>(UserAvatarDelete_Shared_Mutation, {
    ...options,
    refetchQueries: [
      {
        query: UserAvatar_Shared_Query,
        variables: {
          filter: AvatarSize.SMALL,
        },
      },
    ],
  });

export type { UserAvatarDeleteData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useUserAvatarDeleteMutation, UserAvatarDelete_Shared_Mutation, UserAvatar_Shared_Query };
